export default {
  text: 'white',
  primary: '#be2f27',
  secondary: '#dc9f17',
  background: '#1d2020',
  backgroundSecondary: '#6c9d2a',
  light: '#FFF',
  dark: '#272727'
}
